const cls = (...classnames) => classnames.join(" ");

const scrollToTop = () => {
  window.scrollTo(0, 0);
};

export { cls, scrollToTop };
